import React, { useState } from "react";
import "./ScalabilityCapable.css";

export default function ScalabilityCapable() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const cards = [
    {
      id: 1,
      title: "Scalable Architecture Design",
      description:
        "We design cloud-native and microservices architectures that support both horizontal and vertical scaling, ensuring applications remain flexible, resilient, and performance-driven as workloads and user demand grow.",
    },
    {
      id: 2,
      title: "Auto-Scaling Infrastructure",
      description:
        "Automated scaling policies dynamically adjust compute, storage, and network resources in real time, ensuring optimal performance during peak demand while controlling costs during low-usage periods.",
    },
    {
      id: 3,
      title: "Container & Kubernetes Scaling",
      description:
        "We enable efficient scaling of containerized applications using Kubernetes, ensuring high availability, workload balance, and rapid response to changing traffic and application demands.",
    },
    {
      id: 4,
      title: "Load Balancing & Traffic Management",
      description:
        "Intelligent load balancing and traffic routing distribute user requests evenly across services, maintaining availability, reducing latency, and preventing performance bottlenecks during traffic spikes.",
    },
    {
      id: 5,
      title: "Database & Storage Scalability",
      description:
        "We design scalable database and storage architectures that handle increasing data volumes while maintaining performance, availability, and data integrity across distributed environments.",
    },
    {
      id: 6,
      title: "Performance Testing & Capacity Planning",
      description:
        "Through load testing and predictive capacity planning, we identify scalability limits early and ensure infrastructure is prepared to support future growth reliably and efficiently.",
    },
  ];

  return (
    <div id="scalability-capable" className="dappmainclass">
      <div className="top">
        <div className="left">
          <h2 className="heading">Our Scalability Capabilities </h2>
          <p className="subheading">
            Designing scalable, flexible, and resilient systems that adapt to
            growing workloads while ensuring consistent performance,
            reliability, and long-term operational stability.
          </p>
        </div>
        <div className="right">
          <button>Get in touch</button>
        </div>
      </div>

      <div className="cards">
        {cards.map((card) => (
          <div className="card" key={card.id}>
            <h3>{card.title}</h3>
            <span>{card.description}</span>
          </div>
        ))}
      </div>

      <div className="carousel-container">
        <div className="carousel-wrapper">
          <div
            className="carousel-track"
            style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          >
            {cards.map((card) => (
              <div className="carousel-card" key={card.id}>
                <h3>{card.title}</h3>
                <span>{card.description}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="carousel-dots">
        {cards.map((_, index) => (
          <button
            key={index}
            className={`dot ${currentSlide === index ? "active" : ""}`}
            onClick={() => setCurrentSlide(index)}
          />
        ))}
      </div>
    </div>
  );
}
